var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"date-content"},[_vm._v(_vm._s(_vm.published_date))]),(_vm.$vuetify.breakpoint.smAndDown)?_c('p',{staticClass:"news-content blue-security font-weight-bold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"news-content",attrs:{"align":"justify"},domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }